export class RegistrationInfo {
    name: string = "";
    email: string = "";
    phone: string = "";
    password: string = "";
    conf_pass: string = "";
}
